import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BottomNavItem } from 'components/Auth0Animation/components';
import { BottomNavList } from './styled';

const steps = {
  1: {
    step: 1,
    name: 'Use cases'
  },
  2: {
    step: 2,
    name: 'Technologies'
  },
  3: {
    step: 3,
    name: 'Deployment'
  },
  4: {
    step: 4,
    name: 'Customization'
  },
  5: {
    step: 5,
    name: 'Result'
  }
};

class BottomNav extends Component {
  static propTypes = {
    action: PropTypes.func.isRequired,
    active: PropTypes.number.isRequired
  };

  renderItem = i => (
    <BottomNavItem
      key={i}
      step={steps[i].step}
      action={this.props.action}
      name={steps[i].name}
      activeClass={steps[i].step === this.props.active ? 'active' : ''}
    />
  );

  render() {
    const stepKeys = Object.keys(steps);
    return (
      <BottomNavList className={stepKeys.length === this.props.active ? 'completed' : ''}>
        {Object.keys(steps).map(this.renderItem)}
      </BottomNavList>
    );
  }
}

export default BottomNav;



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/BottomNav/BottomNav.js